import { type Writable, writable } from 'svelte/store';

export const cookiesConsent: Writable<boolean> = writable(false);

function setConsent(value: boolean) {
	cookiesConsent.set(value);
	localStorage.setItem('cookiesConsent', value.toString());
}

export { setConsent };
